import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  container: {
    width: '100%',
    height: '100%',
    overflow: 'scroll',
  },
  containerInside: {
    maxWidth: '900px',
    margin: '0px auto',
    marginTop: '20px',
    padding: 10,
    lineHeight: '170%',
  },
  questionIcon: {
    marginRight: 15,
  },
}));



// WEBPACK FOOTER //
// ./src/components/Faqs/useStyles.js